import React from 'react';
import { Store } from 'react-notifications-component';
import { Toast } from '../../components/ui/Toast';

/**
 * Notification(msg, isSucess) — helper toast unique du marketplace.
 *
 * Signature INCHANGÉE (§69) : ~50 appelants en dépendent.
 * Rend la primitive DA `Toast` (§62, src/components/ui/Toast.jsx) via le
 * mécanisme `content` de react-notifications-component, ce qui remplace le
 * rendu générique de la lib par la carte DA (StatusDot + eyebrow mono +
 * message + barre minuteur magenta + croix cerclée).
 *
 * Positionnement (container "bottom-right") géré dans src/App.css
 * (décalé de la bulle chatbot earni-assistant).
 */
const DURATION = 4000;

const Notification = (msg, isSucess) => {
  const type = isSucess ? 'success' : 'danger';
  // Garde anti-crash : Store.addNotification exécute this.add(), qui reste null tant
  // qu'aucun <ReactNotifications /> n'est monté sur la page (les containers sont montés
  // PAR PAGE dans cette codebase). Sans garde, un toast émis depuis une page sans
  // container (cas vécu : /cart, item indisponible → CartCheckoutModal → toast) jette
  // "this.add is not a function" en plein rendu → error boundary → page entière morte.
  // Un toast perdu se logue en warning, il ne casse JAMAIS la page.
  try {
    Store.addNotification({
      content: ({ id }) => (
        <Toast
          type={type}
          title={isSucess ? 'Success' : 'Failed'}
          message={msg}
          duration={DURATION}
          onClose={() => Store.removeNotification(id)}
        />
      ),
      insert: 'top',
      container: 'bottom-right',
      width: 340,
      animationIn: ['animate__animated', 'animate__fadeIn'],
      animationOut: ['animate__animated', 'animate__fadeOut'],
      dismiss: {
        duration: DURATION,
        onScreen: true,
      },
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[Toast] no <ReactNotifications /> container mounted on this page, toast dropped:', msg);
  }
};

export default Notification;
